import { useCallback, useState } from "react";
import { applyAdminSortClick, nextAdminSortConfig } from "../utils/adminGridClientSort";

export function useAdminSortState(nextConfig = nextAdminSortConfig) {
  const [sortConfig, setSortConfig] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const handleSort = useCallback(
    (key) => applyAdminSortClick(setSortConfig, setCurrentPage, key, nextConfig),
    [nextConfig]
  );

  return { sortConfig, setSortConfig, currentPage, setCurrentPage, handleSort };
}
